import React from 'react';
import {
  Box,
  Grid,
  HStack,
  Skeleton,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FiClipboard, FiFileText, FiPackage, FiTruck } from 'react-icons/fi';
import { SaktiBccKpiData } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiBccKpiCardsProps {
  loading: boolean;
  data: SaktiBccKpiData;
}

const formatNumber = (value: number) => value.toLocaleString('id-ID');

const SaktiBccKpiCards: React.FC<SaktiBccKpiCardsProps> = ({ loading, data }) => {
  const cards = [
    {
      key: 'total-bcc',
      label: 'TOTAL BCC',
      value: formatNumber(data.total_bcc),
      unit: 'item',
      icon: FiClipboard,
      color: 'blue',
    },
    {
      key: 'total-janjang',
      label: 'TOTAL JANJANG',
      value: formatNumber(data.total_bunch),
      unit: 'jjg',
      icon: FiPackage,
      color: 'green',
    },
    {
      key: 'restan',
      label: 'RESTAN (BELUM ANGKUT)',
      value: formatNumber(data.total_restan),
      unit: 'jjg',
      icon: FiTruck,
      color: 'orange',
    },
    {
      key: 'ba',
      label: 'BERITA ACARA',
      value: formatNumber(data.total_bcc), // Assuming we use same data or similar
      unit: 'BA',
      icon: FiFileText,
      color: 'red',
    },
  ];

  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(4, 1fr)' }} gap={3}>
      {cards.map((card) => (
        <Skeleton key={card.key} isLoaded={!loading} borderRadius={SAKTI_UI_SIZE.cardRadius}>
          <Box
            bg="white"
            borderRadius={SAKTI_UI_SIZE.cardRadius}
            p={SAKTI_UI_SIZE.cardPadding}
            borderWidth="1px"
            borderColor="gray.200"
          >
            <VStack align="stretch" spacing={3}>
              <HStack justify="space-between" align="start">
                <Box
                  bg={`${card.color}.50`}
                  color={`${card.color}.600`}
                  borderRadius="md"
                  p={1.5}
                  display="inline-flex"
                  alignItems="center"
                  justifyContent="center"
                  boxSize={SAKTI_UI_SIZE.kpiIconBoxSize}
                >
                  <card.icon />
                </Box>
              </HStack>

              <Stat>
                <StatLabel fontSize={SAKTI_UI_SIZE.kpiLabel} letterSpacing="wider" color="gray.500">
                  {card.label}
                </StatLabel>
                <HStack align="end" spacing={1}>
                  <StatNumber fontSize={SAKTI_UI_SIZE.kpiValue}>{card.value}</StatNumber>
                  <Text color="gray.500" pb={1} fontSize="xs">
                    {card.unit}
                  </Text>
                </HStack>
              </Stat>
            </VStack>
          </Box>
        </Skeleton>
      ))}
    </Grid>
  );
};

export default SaktiBccKpiCards;
